<div class="modal is-active">
  <div class="modal-background" [@modalbackground]="Closing ? 'close' : ''"></div>
  <div class="modal-card" [@modalopen]="Closing ? 'close' : ''">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ IsNew ? 'Add Plate Entry' : 'Edit Plate Entry' }}</p>
    </header>
    <form [formGroup]="Form">
      <section class="modal-card-body">
        <app-field Label="Plate Number">
          <div class="control">
            <input formControlName="PlateNumber" class="input" type="text" placeholder="Enter plate number" />
            <app-validator [For]="Form.get('PlateNumber')"></app-validator>
          </div>
        </app-field>
        <app-field Label="Region Code">
          <div class="control">
            <input formControlName="RegionCode" class="input" type="text" placeholder="e.g. NSW, VIC" />
            <app-validator [For]="Form.get('RegionCode')"></app-validator>
          </div>
        </app-field>
        <app-field Label="Expiry Date">
          <div class="control">
            <input formControlName="ExpiresOnLocal" class="input" type="date" />
          </div>
        </app-field>
        <app-field Label="Notes">
          <div class="control">
            <textarea formControlName="Notes" class="textarea" placeholder="Optional notes"></textarea>
            <app-validator [For]="Form.get('Notes')"></app-validator>
          </div>
        </app-field>
      </section>
      <footer class="modal-card-foot">
        <app-form-save-button [Form]="Form" (OnSave)="Save()"></app-form-save-button>
        <button class="button ml-3" type="button" (click)="Cancel()">Cancel</button>
      </footer>
    </form>
  </div>
</div>
